/** Single source of truth for the public support phone number. */
export const SUPPORT_PHONE_DISPLAY = '866.819.5055';
export const SUPPORT_PHONE_TEL = '+18668195055';
